import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Select, MenuItem } from '@material-ui/core';

class Dropdown extends Component {
  optionToMenuItem = element => {
    return (
      <MenuItem key={`dropdown-${element.value}`} value={element.value}>
        {element.displayValue}
      </MenuItem>
    );
  };

  render() {
    const { className, onChange, name, options, tabIndex, value, disabled } = this.props;
    return (
      <Select
        className={className}
        inputProps={{ tabIndex }}
        fullWidth
        value={value}
        onChange={onChange}
        name={name}
        disableUnderline
        disabled={disabled}
      >
        {options.map(this.optionToMenuItem)}
      </Select>
    );
  }
}

Dropdown.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
};

Dropdown.defaultProps = {
  className: undefined,
  disabled: undefined,
  tabIndex: 0,
};

export default Dropdown;
